import { IFormAlertType } from 'types/forms/formTypes';

//TODO: will be implement later to get this list from backend
export const STATES =
  [
    { code: 'ACT', name: 'Australian Capital Territory' },
    { code: 'NSW', name: 'New South Wales' },
    { code: 'NT', name: 'Northern Territory' },
    { code: 'QLD', name: 'Queensland' },
    { code: 'SA', name: 'South Australia' },
    { code: 'TAS', name: 'Tasmania' },
    { code: 'VIC', name: 'Victoria' },
    { code: 'WA', name: 'Western Australia' }
  ];
//TODO: will be implement later to get this list from backend
export const STATE_AND_TERRITORY_CODE =
{
  ACT: 'ACT',
  NSW: 'NSW',
  NT: 'NT',
  QLD: 'QLD',
  SA: 'SA',
  TAS: 'TAS',
  VIC: 'VIC',
  WA: 'WA'
};

//For different identity document types
export const IDENTITY_TYPES =
{
  AU_PASSPORT: 'PP',
  AU_BIRTH_CERTIFICATE: 'BC',
  AU_CITIZENSHIP_CERTIFICATE: 'CC',
  FORIGN_PASSPORT: 'PP_I',
  IMMI_CARD: 'IM',
  MANUAL_UPLOAD:'ManualUpload'
};

//TODO: will be implement later to get this list from backend
export const TITLES =
  [
    'Master',
    'Mr',
    'Miss',
    'Mrs',
    'Ms',
    'Dr'
  ];

//For different name change document types
export const NAME_CHANGE_DOC_TYPES =
{
  NAME_CHANGE_CERTIFICATE: 'NC',
  MARRIAGE_CERTIFICATE: 'MC',
  DIVORCE_PAPERS: 'DIV',
  NONE: 'NONE'
};

//Alter when form validation failed
export const FORM_VALIDATION_ERROR_ALERT: IFormAlertType = {
  as: 'error',
  title: 'There was a problem submitting the form.',
  message: 'Please check the form again before proceeding.'
};

export const DAMP_FORM_VALIDATION_ERROR_ALERT: IFormAlertType = {
  as: 'error',
  title: 'There was a problem with the form',
  message: 'Please check the form below and try again'
};

export const DVS_VERIFICATION_RESULT_CODE = {
  NO_MATCH: 'N',
  SYSTEM_ERROR: 'S',
  DATA_ERROR: 'D',
  MATCH: 'Y'
};

export const MANUAL_POI_PRIMARY_DOCUMENTS_70POINTS = [
  'Foreign passport (current)',
  'Australian passport (current or expired within the last 2 years, but not cancelled)',
  'Australian citizenship certificate',
  'Full birth certificate (not extract, Australian or foreign)',
  'Certificate of identity issued by the Australian Government to refugees and non-Australian citizens for entry to Australia'
];

export const MANUAL_POI_PRIMARY_DOCUMENTS_40POINTS = [
  'Australian driver licence or learner permit',
  'Current (Australian) tertiary student ID card',
  'Photo identification card issued for Australian regulatory purposes (for example aviation/maritime security ID or security industry ID)',
  'Government employee ID (Australian federal/state/territory)',
  'Defence Force ID card (with photo or signature)'
];

export const MANUAL_POI_SECONDARY_DOCUMENTS_40POINTS = [
  'Medicare card',
  'Department of Veterans Affairs (DVA) card',
  'Centrelink card (with reference number)'
];

export const MANUAL_POI_SECONDARY_DOCUMENTS_25POINTS = [
  'Birth certificate extract (Australian or foreign)',
  'Birth card (NSW Registry of Births Deaths and Marriages only)',
  'Credit card or account card',
  'Australian marriage certificate (Registry issue only)',
  'Australian divorce certificate (Registry issue only)',
  'Change of name certificate (Registry issue only)',
  'Bank statement',
  'Property lease agreement – current address',
  'Taxation assessment notice',
  'Australian mortgage documents',
  'Rating authority – such as land rates',
  'Utility bill – electricity, gas, telephone (less than 12 months old)',
  'Reference from Indigenous organisation',
  'Documents issued outside Australia (equivalent to Australian documents)'
];